export const MOTION_TYPES = {
  EMOTION: 'EMOTION',
  ACTION: 'ACTION',
  WEAPON: 'WEAPON',
};
export const DEFAULT_MOTIONS = {
  [MOTION_TYPES.EMOTION]: 'E00',
  [MOTION_TYPES.ACTION]: 'A00',
  [MOTION_TYPES.WEAPON]: 'W00',
};
